import axios from "axios";
import { getCookie } from "./helpers/cookies";
import { API_URL } from "./config";

class Api {
    constructor() {
        this.client = axios.create({
            baseURL: API_URL,
            timeout: 120000, // Timeout global de 2 minutos (en milisegundos)
            headers: {
                Authorization: 'Bearer ' + getCookie('api_token'),
            },
        });
    }

    requestHandler = async (method, endpoint, data = null, config = {}) => {
        try {
            const response = await this.client.request({
                method,
                url: endpoint,
                data,
                ...config,
            });
            return response.data;
        } catch (error) {
            console.error('API error:', error);
            throw error;
        }
    };

    login = async (data) => this.requestHandler("POST", "login", data);

    getUsers = async () => this.requestHandler("GET", "users/get");

    getOperaciones = async () => this.requestHandler("GET", "admin/operaciones/get");

    getClases = async () => this.requestHandler("GET", "clases/get-all");

    getOperacionesHistorial = async (fecha) =>
        this.requestHandler("GET", `admin/operaciones/get-historial/${fecha}`);

    setOperacion = async (data) =>
        this.requestHandler("POST", "admin/operaciones/aprobar-rechazar", data);

    getUser = async (id) => this.requestHandler("GET", `users/getone/${id}`);


    getVFondosAgentesColocadores = async (id) =>
        this.requestHandler("GET", `vfondos/get-agentes-colocadores/${id}`);

    getVFondosOficialesCuenta = async (id) =>
        this.requestHandler("GET", `vfondos/get-oficiales-cuenta/${id}`);

    getVFondosAgentesFinancieros = async (id) =>
        this.requestHandler("GET", `vfondos/get-agentes-financieros/${id}`);

    getAgentes = async () => this.requestHandler("GET", "agentes/get");

    getAgente = async (id) => this.requestHandler("GET", `agentes/get-one/${id}`);

    saveAgente = async (data) => this.requestHandler("POST", "agentes/save", data);

    attachAgenteColocador = async (data) =>
        this.requestHandler("POST", "agentes/save-agente", data);

    attachOficialCuenta = async (data) =>
        this.requestHandler("POST", "agentes/save-oficial-cuenta", data);

    detachAgente = async (data) =>
        this.requestHandler("POST", "agentes/delete-agente", data);

    detachOficialCuenta = async (data) =>
        this.requestHandler("POST", "agentes/delete-oficial-cuenta", data);

    attachAgenteFinanciero = async (data) =>
        this.requestHandler("POST", "agentes/save-agente-financiero", data);

    detachAgenteFinanciero = async (data) =>
        this.requestHandler("POST", "agentes/delete-agente-financiero", data);

    getOperacionesFondos = async (agenteId, fechaDesde, fechaHasta) =>
        this.requestHandler(
            "GET",
            `agentes/get-operaciones-fondos/${agenteId}/${fechaDesde}/${fechaHasta}`
        );

    getOperacionesComisiones = async (agenteId, fechaDesde, fechaHasta) =>
        this.requestHandler(
            "GET",
            `agentes/get-operaciones-comisiones/${agenteId}/${fechaDesde}/${fechaHasta}`
        );

    getComisionesResumen = async (fechaDesde, fechaHasta) =>
        this.requestHandler(
            "GET",
            `agentes/resumen-comisiones/${fechaDesde}/${fechaHasta}`
        );

    sendEmailMasivo = async (data) =>
        this.requestHandler("POST", "agentes/send-email", data);

    getPosicionCuotapartista = async (agenteId, fecha) =>
        this.requestHandler(
            "GET",
            `agentes/get-posiciones-fondos/${agenteId}/${fecha}`
        );

    getStockCuotapartista = async (agenteId, fechaDesde, fechaHasta) =>
        this.requestHandler(
            "GET",
            `agentes/get-stock-fondos/${agenteId}/${fechaDesde}/${fechaHasta}`
        );

    getExportAnalisis = async (
        agenteId,
        fechaDesde,
        fechaHasta,
        soloComisiones,
        aperturaCuotapartista
    ) =>
        this.requestHandler(
            "GET",
            `agentes/get-excel/${agenteId}/${fechaDesde}/${fechaHasta}/${soloComisiones}/${aperturaCuotapartista}`
        );

    getExportAnalisisPDF = async (agenteId, fechaDesde, fechaHasta) =>
        this.requestHandler(
            "GET",
            `agentes/get-pdf/${agenteId}/${fechaDesde}/${fechaHasta}`
        );

    getOperacionesFinancieras = async (agenteId, fechaDesde, fechaHasta) =>
        this.requestHandler(
            "GET",
            `agentes/get-operaciones-financieras/${agenteId}/${fechaDesde}/${fechaHasta}`
        );

    saveUser = async (data) => this.requestHandler("POST", "users/save", data);

    getTipoCambio = async () => this.requestHandler("GET", "dolar-ccl/get");

    saveTipoCambio = async (data) =>
        this.requestHandler("POST", "dolar-ccl/save", data);
}

export default new Api();
